import { logUsage } from 'owa-analytics';
import FilePickerAction from '../store/schema/FilePickerAction';
import {
    AttachOrSharePreference,
    FilePickerUserConfigurationProperty,
} from '../store/schema/FilePickerUserConfiguration';

export default function getUserPreferredFilePickerAction(
    actionPreference: FilePickerUserConfigurationProperty<AttachOrSharePreference>
): FilePickerAction {
    if (!actionPreference) {
        logUsage('AttachmentUserPreferenceSetting', { preference: AttachOrSharePreference.None });
        return null;
    }

    switch (actionPreference.value) {
        case AttachOrSharePreference.Attach:
            logUsage('AttachmentUserPreferenceSetting', {
                preference: AttachOrSharePreference.Attach,
            });
            return FilePickerAction.Attach;
        case AttachOrSharePreference.Share:
            logUsage('AttachmentUserPreferenceSetting', {
                preference: AttachOrSharePreference.Share,
            });
            return FilePickerAction.Share;
        default:
            logUsage('AttachmentUserPreferenceSetting', {
                preference: AttachOrSharePreference.None,
            });
            return null;
    }
}
